/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateActorAccess.defs.js'
export { main as default } from './updateActorAccess.defs.js'
